import { apiUrl } from '../../../utils/api';
import { apiBasePath } from '../../BasicUrl';


const Common = apiBasePath.injectEndpoints({
    endpoints: (build) => ({
        getCity: build.query({
            query: () => ({
                url: `${apiUrl.city}`,
            }),
        }),
        getState: build.query({
            query: () => ({
                url: `${apiUrl.state}`,
            }),
        }),
        getAria: build.query({
            query: (id) => ({
                url: `${apiUrl.area}?id=${id}`,
            }),
        }),
        getPincode: build.query({
            query: () => ({
                url: `${apiUrl.area}`,
            }),
        }),
        getCategory: build.query({
            query: () => ({
                url: `${apiUrl.category}`,
            }),
        }),
        getSubCategory: build.query({
            query: (id) => ({
                url: `${apiUrl.subcategories}?id=${id}`,
            }),
        }),
        activateAccountApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.activeteAccount}`,
                method: "POST",
                body: data
            }),
        }),
    }),
    overrideExisting: false,
});

export const { useGetPincodeQuery, useGetCityQuery, useGetCategoryQuery, useGetSubCategoryQuery, useGetAriaQuery, useGetStateQuery, useActivateAccountApiMutation } = Common;
